var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVideoLibrary = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "28px",
    viewBox: "0 0 32 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0C433EB4-FD0D-4D0B-AEAF-14AD326B4044") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.290222 0 0 0 0 0.290175 0 0 0 0 0.290237 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "11.0-Help-Center",
    transform: "translate(-205.000000, -430.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(165.000000, 392.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "video-library",
    transform: "translate(40.000000, 32.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1787666,0 L4.79625293,0 C2.14735558,0 0,2.08933783 0,4.66666667 L0,23.3333333 C0,25.9106622 2.14735558,28 4.79625293,28 L27.1787666,28 C29.8276639,28 31.9750195,25.9106622 31.9750195,23.3333333 L31.9750195,4.66666667 C31.9750195,2.08933783 29.8276639,0 27.1787666,0 Z M28.7775176,23.3333333 C28.7775176,24.1924429 28.0617324,24.8888889 27.1787666,24.8888889 L4.79625293,24.8888889 C3.91328714,24.8888889 3.19750195,24.1924429 3.19750195,23.3333333 L3.19750195,4.66666667 C3.19750195,3.80755706 3.91328714,3.11111111 4.79625293,3.11111111 L27.1787666,3.11111111 C28.0617324,3.11111111 28.7775176,3.80755706 28.7775176,4.66666667 L28.7775176,23.3333333 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1818891,12.6466667 L11.9906323,6.42444444 C11.495977,6.14657121 10.8865366,6.14657121 10.3918813,6.42444444 C9.89525462,6.70341928 9.59022922,7.21982371 9.5924932,7.77777778 L9.5924932,20.2222222 C9.59022922,20.7801763 9.89525462,21.2965807 10.3918813,21.5755556 C10.6355356,21.7099251 10.9111934,21.7796597 11.1912568,21.7778149 C11.4713202,21.7796597 11.746978,21.7099251 11.9906323,21.5755556 L23.1818891,15.3533333 C23.6827945,15.077127 23.9923732,14.5601975 23.9923732,14 C23.9923732,13.4398025 23.6827945,12.922873 23.1818891,12.6466667 Z M12.7900078,17.5466667 L12.7900078,10.4533333 L19.1850117,14 L12.7900078,17.5466667 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVideoLibrary);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/videoLibrary.b4b0ec4ee42694f294794c1a306e49ac.svg";